import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export function EmailShowcase({ items }) {
  const [open, setOpen] = useState(null);

  return (
    <section data-testid="designs-section" className="bg-navy">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <h2 className="text-[26px] font-normal leading-[1.15] text-white md:text-[32px]">
            The <strong className="font-bold">emails</strong>
          </h2>
          <p className="text-xs font-medium uppercase tracking-widest text-white/50">Click any email to enlarge</p>
        </div>
        <div className="mt-8 flex flex-wrap items-start justify-center gap-6">
          {items.map((d, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.45 }}
              data-testid={`design-${i}`}
              className={`w-full max-w-[360px] sm:w-[calc(50%-12px)] ${items.length <= 2 ? "md:w-[360px]" : "md:w-[264px]"}`}
            >
              <button
                onClick={() => setOpen(d)}
                aria-label={`Open email: ${d.caption}`}
                className="block w-full overflow-hidden rounded-2xl bg-white shadow-[0_24px_60px_-20px_rgba(0,0,0,0.6)] ring-1 ring-white/10"
              >
                <img src={d.src} alt={d.caption} loading="lazy" className="w-full" />
              </button>
              <figcaption className="mt-4 text-sm leading-snug text-white/80">{d.caption}</figcaption>
            </motion.figure>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="email-lightbox"
            className="fixed inset-0 z-50 overflow-y-auto bg-navy/95 p-5 md:p-10"
            onClick={() => setOpen(null)}
          >
            <button data-testid="email-lightbox-close" aria-label="Close" className="fixed right-5 top-5 z-10 rounded-full bg-white/10 p-2 text-white hover:bg-white/20">
              <X size={24} />
            </button>
            <motion.figure
              initial={{ y: 24 }}
              animate={{ y: 0 }}
              className="mx-auto w-full max-w-[520px]"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={open.src} alt={open.caption} className="w-full rounded-2xl" />
              <figcaption className="mt-4 text-center text-sm text-white/80">{open.caption}</figcaption>
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
